module.exports = __webpack_public_path__ + "static/media/blackUpDown.e855b57f.svg";